<template>
    <transition
        :css="false"
        @enter="intro"
        @leave="outro"
    >
        <div class="LineIcon" :class="modifiers" :style="style">
            <svg :viewBox="stageViewBox">
                <path ref="path" class="LineIcon-path" :d="d"/>
            </svg>
        </div>
    </transition>
</template>

<script>
import 'gsap/DrawSVGPlugin'
export default {
    name: 'LineIcon',
    props: {
        d: {
            type: String,
            required: true,
        },
        width: {
            type: Number,
            default: 50,
        },
        height: {
            type: Number,
            default: 50,
        },
        introDuration: {
            type: Number,
            default: 0.8,
        },
        outroDuration: {
            type: Number,
            default: 0.8,
        },
        introDelay: {
            type: Number,
            default: 0,
        },
        outroDelay: {
            type: Number,
            default: 0,
        },
        loop: {
            type: Boolean,
            default: false,
        },
        hovered: {
            type: Boolean,
            default: false,
        },
        light: {
            type: Boolean,
            default: false
        },
        dark: {
            type: Boolean,
            default: false,
        },
        opaque: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            timeline: null
        }
    },
    methods: {
        getTimeline() {
            const { $refs } = this
            if (this.timeline === null) {
                const tl = new TimelineMax({ paused: true })
                tl
                    .fromTo($refs.path, this.introDuration, { drawSVG: '0' }, {
                        drawSVG: '100%',
                        delay: this.introDelay,
                        ease: Cubic.easeOut,
                    })
                    .addLabel('intro-done', '+=0')
                    .to($refs.path, this.outroDuration, {
                        drawSVG: '100% 100%',
                        delay: this.outroDelay,
                        ease: Cubic.easeIn,
                    })
                this.timeline = tl
            }
            return this.timeline
        },
        async intro($el, done) {
            const timeline = this.getTimeline()
            timeline.seek(0)
            if (this.loop) {
                await this.initRepeat()
                // Call done after the first loop
                done()
            } else {
                timeline
                    .addCallback(done, 'intro-done')
                    .tweenFromTo(0, 'intro-done')
            }
        },
        outro($el, done) {
            const timeline = this.getTimeline()
            this.fill = 'blue'
            timeline
                .repeat(0)
                .eventCallback('onComplete', done)
                .resume(timeline.time())
        },
        initRepeat() {
            return new Promise((resolve, reject) => {
                const { timeline } = this
                timeline
                    .eventCallback('onRepeat', () => {
                        resolve()
                        timeline.eventCallback('onRepeat', null)
                    })
                    .repeat(-1)
                    .play()
            })
        },
        onMouseEnter() {
            const timeline = this.getTimeline()
            timeline
                .resume()
                .eventCallback('onComplete', () => {
                    timeline.tweenFromTo(0, 'intro-done')
                })
        },
    },
    computed: {
        modifiers() {
            const { light, dark, opaque } = this
            return {
                'LineIcon--light': light,
                'LineIcon--dark': dark,
                'LineIcon--opaque': opaque,
            }
        },
        style() {
            const { width, height } = this
            return {
                'width': `${width}px`,
                'height': `${height}px`,
            }
        },
        stageViewBox() {
            const { width, height } = this
            return `0 0 ${width} ${height}`
        },
    },
    watch: {
        hovered(val) {
            if (val) this.onMouseEnter()
        },
    },
}
</script>

<style src="styles/components/LineIcon.styl" lang="stylus"></style>


// WEBPACK FOOTER //
// src/app/components/LineIcon.vue